import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../../messages';
import { downloadUrl } from '../../../utils';
export var DownloadAction = function DownloadAction(_ref) {
  var url = _ref.url;
  return {
    id: 'download-content',
    text: /*#__PURE__*/React.createElement(FormattedMessage, messages.download),
    promise: function promise() {
      return downloadUrl(url);
    }
  };
};